﻿(function () {
  function updateCartCount(count) {
    const el = document.getElementById('cartCount');
    if (el) el.textContent = count;
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  });

  document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.querySelector('[data-mobile-menu]');
    const openButton = document.querySelector('[data-mobile-menu-open]');
    const closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
    if (!drawer || !openButton) return;

    const openMenu = () => {
      drawer.hidden = false;
      window.requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        document.documentElement.classList.add('mobile-menu-open');
        openButton.setAttribute('aria-expanded', 'true');
      });
    };

    const closeMenu = () => {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('mobile-menu-open');
      openButton.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 280);
    };

    openButton.addEventListener('click', openMenu);
    closeButtons.forEach((button) => button.addEventListener('click', closeMenu));

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) closeMenu();
    });
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-product-share]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const shareData = {
      title: button.getAttribute('data-share-title') || document.title,
      url: button.getAttribute('data-share-url') || window.location.href
    };

    if (navigator.share) {
      navigator.share(shareData).catch(function () {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareData.url).then(function () {
        button.classList.add('is-copied');
        window.setTimeout(function () { button.classList.remove('is-copied'); }, 1200);
      }).catch(function () {
        window.prompt('Copy this product link:', shareData.url);
      });
      return;
    }

    window.prompt('Copy this product link:', shareData.url);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.querySelector('[data-search-overlay]');
    const input = document.querySelector('[data-search-input]');
    const results = document.querySelector('[data-search-results]');
    const quickLinks = document.querySelector('[data-search-quick-links]');
    const openButtons = document.querySelectorAll('[data-search-open]');
    const closeButtons = document.querySelectorAll('[data-search-close]');
    let timer = null;
    let lastQuery = '';

    if (!overlay || !input || !results) return;

    const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]);

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      const prefix = window.JodyKoesTheme && window.JodyKoesTheme.moneyPrefix ? window.JodyKoesTheme.moneyPrefix : 'Rs.';
      const locale = window.JodyKoesTheme && window.JodyKoesTheme.moneyLocale ? window.JodyKoesTheme.moneyLocale : 'en-IN';
      return `${prefix} ${amount.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const openSearch = () => {
      overlay.hidden = false;
      document.documentElement.classList.add('search-open');
      window.setTimeout(() => input.focus(), 40);
    };

    const closeSearch = () => {
      overlay.hidden = true;
      document.documentElement.classList.remove('search-open');
    };

    const productThumb = (product) => {
      const image = product.image || product.featured_image || {};
      const src = typeof image === 'string' ? image : image.url || image.src || '';
      if (!src) return '<span>JK</span>';
      return `<img src="${escapeHtml(src)}" alt="${escapeHtml(product.title)}" loading="eager">`;
    };

    const renderResults = (payload, query) => {
      const resources = payload && payload.resources && payload.resources.results ? payload.resources.results : {};
      const products = resources.products || [];
      const collections = resources.collections || [];
      const html = [];

      if (products.length) {
        html.push('<div class="search-overlay__group-title">Products</div>');
        products.slice(0, 6).forEach((product) => {
          html.push(`
            <a class="search-overlay__item" href="${escapeHtml(product.url)}">
              <span class="search-overlay__thumb">${productThumb(product)}</span>
              <span>
                <strong>${escapeHtml(product.title)}</strong>
                <small>${escapeHtml(product.vendor || product.type || 'JodyKoes')}</small>
              </span>
              <span class="search-overlay__price">${product.price_min ? formatMoney(product.price_min) : ''}</span>
            </a>
          `);
        });
      }

      if (collections.length) {
        html.push('<div class="search-overlay__group-title">Collections</div>');
        collections.slice(0, 5).forEach((collection) => {
          html.push(`
            <a class="search-overlay__item" href="${escapeHtml(collection.url)}">
              <span class="search-overlay__thumb"><span>JK</span></span>
              <span>
                <strong>${escapeHtml(collection.title)}</strong>
                <small>Collection</small>
              </span>
            </a>
          `);
        });
      }

      if (!html.length) {
        results.innerHTML = '<p class="search-overlay__empty">No results found. Try another product or collection.</p>';
        return;
      }

      html.push(`<a class="search-overlay__view-all" href="/search?q=${encodeURIComponent(query)}">View all search results</a>`);
      results.innerHTML = html.join('');
    };

    const search = (query) => {
      const cleanQuery = query.trim();
      lastQuery = cleanQuery;
      if (!cleanQuery) {
        if (quickLinks) quickLinks.hidden = false;
        results.innerHTML = '<p class="search-overlay__hint">Start typing to search products and collections.</p>';
        return;
      }

      if (quickLinks) quickLinks.hidden = true;
      results.innerHTML = '<p class="search-overlay__hint">Searching...</p>';

      fetch(`/search/suggest.json?q=${encodeURIComponent(cleanQuery)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error('search failed')))
        .then((payload) => {
          if (lastQuery === cleanQuery) renderResults(payload, cleanQuery);
        })
        .catch(() => {
          if (lastQuery === cleanQuery) {
            results.innerHTML = '<p class="search-overlay__empty">Search is unavailable for a moment. Please try again.</p>';
          }
        });
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openSearch();
      });
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeSearch));

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => search(input.value), 180);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hidden) closeSearch();
    });
  });
})();
